import React from 'react'
import { Outlet } from 'react-router-dom'
import { Modal as UIModal } from '@pet-notify/ui'

function Modal({children, ...props }) {
  return (
    <UIModal {...props}>
      {children}
    </UIModal>
  )
}
export default Modal
